import { render, staticRenderFns } from "./ReportCenter.vue?vue&type=template&id=080b2c94&scoped=true"
import script from "./ReportCenter.vue?vue&type=script&lang=js"
export * from "./ReportCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../wscpet/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b2c94",
  null
  
)

export default component.exports